<template>
  <div>
    <PageTitle title="Event Details" :backBtn="true" />

    <v-container>
      <v-row class="rowspace">
        <v-col cols="6">
          <v-row>
            <v-col cols="6" sm="12" md="6" lg="6"><h4>Event Code</h4></v-col>
            <v-col cols="6" sm="12" md="6" lg="6" style="text-align: right"
              ><v-chip label text-color="white" dark>
                {{ events.eventType.code }}</v-chip
              ></v-col
            ></v-row
          >
        </v-col>
        <v-col cols="6">
          <v-row>
            <v-col cols="6" sm="6" md="6" lg="6"><h4>Visibility</h4></v-col>
            <v-col cols="6" sm="6" md="6" lg="6" style="text-align: right">
              <v-chip label style="background-color: #c11e65; color: white">
                {{ events.visibility }}
              </v-chip></v-col
            ></v-row
          ></v-col
        >
      </v-row>
    </v-container>

    <v-container fluid class="lighten-12 container">
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-card class="lighten-12">
            <v-card-title class="v-card__title">General</v-card-title>
            <v-container fluid class="container">
              <v-row>
                <v-col cols="12" sm="12" md="6" lg="6" class="pt-0">
                  <v-row class="pt-0">
                    <v-col cols="6" sm="6" md="6" lg="6" class="pt-1.5 pb-1">
                      <h4>Event Title</h4>
                    </v-col>
                    <v-col
                      cols="6"
                      sm="6"
                      md="6"
                      lg="6"
                      class="pt-1.5 pb-1 text-right"
                    >
                      <v-chip label> {{ events.title }}</v-chip>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" sm="6" md="6" lg="6" class="pt-1.5 pb-1">
                      <h4>Description</h4>
                    </v-col>
                    <v-col
                      cols="6"
                      sm="6"
                      md="6"
                      lg="6"
                      class="pt-1.5 pb-1 text-right"
                    >
                      <v-chip label>{{ events.description }} </v-chip>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" sm="6" md="6" lg="6" class="pt-1.5 pb-1">
                      <h4>Repeat</h4>
                    </v-col>
                    <v-col
                      cols="6"
                      sm="6"
                      md="6"
                      lg="6"
                      class="pt-1.5 pb-1 text-right"
                    >
                      <v-chip label>{{ events.repeat }} </v-chip>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" sm="6" md="6" lg="6" class="pt-1.5 pb-1">
                      <h4>Event Type</h4>
                    </v-col>
                    <v-col
                      cols="6"
                      sm="6"
                      md="6"
                      lg="6"
                      class="pt-1.5 pb-1 text-right"
                    >
                      <v-chip label>{{ events.eventType.name }} </v-chip>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6" sm="6" md="6" lg="6" class="pt-1.5 pb-1">
                      <h4>Holiday</h4>
                    </v-col>
                    <v-col
                      cols="6"
                      sm="6"
                      md="6"
                      lg="6"
                      class="pt-1.5 pb-1 text-right"
                    >
                      <v-chip label>
                        {{
                          events.is_holiday ? events.is_holiday : '_____'
                        }}</v-chip
                      >
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" sm="12" md="6" lg="6" class="pt-0">
                  <v-row>
                    <v-col cols="6" sm="6" md="6" lg="6" class="pt-1 pb-1">
                      <h4>Start Date</h4>
                    </v-col>
                    <v-col
                      cols="6"
                      sm="6"
                      md="4"
                      lg="6"
                      class="pt-1 pb-1 text-right"
                    >
                      <v-chip label style="font-weight: bold" text-color="red">
                        {{ events.start | formatDate }}
                      </v-chip>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" sm="6" md="6" lg="6" class="pt-1.5 pb-1">
                      <h4>End Date</h4>
                    </v-col>
                    <v-col
                      cols="6"
                      sm="6"
                      md="6"
                      lg="6"
                      class="pt-1.5 pb-1 text-right"
                    >
                      <v-chip label style="font-weight: bold" text-color="red">
                        {{ events.end | formatDate }}</v-chip
                      >
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" sm="6" md="6" lg="6" class="pt-1.5 pb-1">
                      <h4>Calendar Color</h4>
                    </v-col>
                    <v-col
                      cols="6"
                      sm="6"
                      md="6"
                      lg="6"
                      class="pt-1.5 pb-1 text-right"
                    >
                      <v-chip label style="font-weight: bold"
                        >{{ events.eventType.color }}
                      </v-chip>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6" sm="6" md="6" lg="6" class="pt-1.5 pb-1">
                      <h4>Repeat All Day</h4>
                    </v-col>
                    <v-col
                      cols="6"
                      sm="6"
                      md="6"
                      lg="6"
                      class="pt-1.5 pb-1 text-right"
                    >
                      <v-chip label style="font-weight: bold">
                        {{ events.all_day }}</v-chip
                      >
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  components: {},

  data: () => ({
    events: [],
  }),

  methods: {
    submit() {
      this.$refs.observer.validate();
      this.EditUser();
    },

    getEvent() {
      let id = this.$route.params.id;

      this.$store
        .dispatch('event/GetEvent', id)
        .then((res) => {
          this.succeeed = true;

          this.events = res.data;
        })
        .catch((err) => {
          this.messages.push(err.data);
          // this.$router.push("/pages/404");
          console.log(err);
        });
    },
  },
  created() {
    this.getEvent();
  },
};
</script>

<style scoped>
.v-card__title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  word-break: break-all;
}

.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  background-color: white;
  margin-bottom: -16px;
}

.rowspace {
  margin-top: -25px;
  margin-bottom: -40px;
}

.pr-100 {
  padding-right: 30px;
}
</style>
